
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getStudentTestingProgress",
      resolverType: "query",
      routePath: "/getStudentTestingProgress",
      httpMethod: "POST",
    });
  